export default "__VITE_ASSET__DV73qFLY__"